enum CustomErrorEnums {
  GENERIC_ERROR = 'generic_error',
  CELEBRATE_ERROR = 'celebrate_error',
  PATIENT_ON_ATTENDANCE = 'patient_on_attendance',
  PROFESSIONAL_ON_ATTENDANCE = 'professional_on_attendance',
}

export default CustomErrorEnums;
